import type {
  ListReceivedLikesData,
  ListReceivedLikesResponse,
} from 'generated/openapi/types.gen';

import { PrivateApi } from '@/shared/api/httpClient/httpClient';

const getReceivedLikesUrl: ListReceivedLikesData['url'] = 'likes/received';

export interface GetReceivedLikesParams {
  pageNumber?: number;
  pageSize?: number;
}

export const getReceivedLikesKey = (pageSize?: number) => [
  ...['likes', 'received', 'list'],
  ...(pageSize ? [pageSize] : []),
];

export const getReceivedLikesFn = async (
  params: GetReceivedLikesParams,
): Promise<ListReceivedLikesResponse> => {
  const { pageNumber, pageSize } = params;
  return PrivateApi.get(getReceivedLikesUrl, {
    searchParams: {
      pageNumber,
      pageSize,
    },
  }).json<ListReceivedLikesResponse>();
};
